import { createSelector } from 'reselect';
import { getProjectLazy } from 'src/modules/common/selectors/getProjectLazy';

export const getHvacData = createSelector([
  getProjectLazy,
], (project) => project.data.hvac);
